import { useApolloClient } from "@apollo/client";

export const useClearApolloCache = () => {
  const client = useApolloClient();

  const clearCache = async () => {
    try {
      await client.clearStore();
    } catch (error) {
      console.error("clearStore error: ", error);
    }
  };

  return clearCache;
};
